import React, { useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { containerStyle } from "../../styles/styles";
import { TableStyles } from "../../styles/table";
import VerticalTabs from "../../tabs";
import TabPanel from "../../common/TabPanel";
import LocalBarIcon from "@material-ui/icons/LocalBar";
import ActiveCancerCareRequest from "../../uis/cancerTables/activeTable";
import PendingCancerCareRequest from "../../uis/cancerTables/pendingTable";

const tabLabels = ["Approved", "Pending"];

const CancerCare = () => {
  const classes = containerStyle();
  const tabClasses = TableStyles();
  const history = useHistory();
  const { activetab } = useParams();

  const tabNameToIndex = {
    0: "approved",
    1: "pending",
  };

  const indexToTabName = {
    approved: 0,
    pending: 1,
  };

  const [tabIndex, setTabIndex] = useState(indexToTabName[activetab]);
  const onChangeTabIndex = (e, newValue) => {
    history.push(`/wellness-on-the-go/cancer-care/${tabNameToIndex[newValue]}`);
    setTabIndex(newValue);
  };
  return (
    <>
      <div className={tabClasses.filterContainer}>
        <p>
          <LocalBarIcon /> Filter by:
        </p>
      </div>
      <div className={classes.main}>
        <div className={tabClasses.tableRoot}>
          <div className={tabClasses.tabsSection}>
            <VerticalTabs
              tabData={tabLabels}
              tabIndex={tabIndex}
              onTabChange={onChangeTabIndex}
            />
          </div>
          <div className={tabClasses.tabPanelContainer}>
            <TabPanel value={0} index={tabIndex}>
              <ActiveCancerCareRequest />
            </TabPanel>
            <TabPanel value={1} index={tabIndex}>
              <PendingCancerCareRequest />
            </TabPanel>
          </div>
        </div>
      </div>
    </>
  );
};

export default CancerCare;
